import api from 'api'
import { CategoriesAPI } from './types'

interface Params {
  page?: number
  perPage?: number
  search?: string
}

const categoriesLibrary = ({ page = 1, perPage = 8, search = '' }: Params) => {
  return api
    .get<CategoriesAPI>('/courses/categories', {
      params: {
        page,
        per_page: perPage,
        search,
        origin: 'library',
      },
    })
    .then(({ data }) => data)
}

export default categoriesLibrary
